import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  selector: 'hour4u-admin-custom-fields',
  templateUrl: './custom-fields.component.html',
  styleUrls: ['./custom-fields.component.scss']
})
export class CustomFieldsComponent implements OnInit {
  customFieldsForm: FormGroup;
  fieldTypes: any[] = [];

  constructor(
    public dialogRef: MatDialogRef<CustomFieldsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _formBuilder: FormBuilder
  ) { }

  ngOnInit() {
    console.log(this.data)
    this.fieldTypes = [
      { value: 'text', display: 'Text' },
      { value: 'textarea', display: 'Text area' },
      { value: 'date', display: 'Date' },
      { value: 'file', display: 'Attachment' },
      { value: 'url', display: 'Link' }
    ];

    this.customFieldsForm = this._formBuilder.group({
      fieldLabel: ['', Validators.required],
      fieldType: ['', Validators.required],
      fieldName: ['', Validators.required],
      fieldValue: [''],
      isMandatory: [false],
      isLoading: [false],
      fileName: [[]],
      value: [[]]
    })
  }

  setFieldLabel(type) {
    console.log(type)
    const fieldName = this.customFieldsForm.controls['fieldLabel'].value;
    const lowerCaseName = fieldName.replaceAll(' ', '_').toLowerCase();
    this.customFieldsForm.controls['fieldName'].setValue(lowerCaseName + "_" + type.value);
  }

  // add Field
  addField() {
    this.dialogRef.close(this.customFieldsForm.value);
  }

}
